import type { TivoPayloadAction } from '../../../../core/tivo/tivo-redux-wrapper';
import {
    ON_KEY_DOWN_RECORDING_ACTIVITY,
    ON_KEY_UP_RECORDING_ACTIVITY,
} from './recordingactivity.navigation.types';

export const onKeyUpRecordingActivityAction = (
    index: number,
): TivoPayloadAction<{ verticalPosition: number }> => ({
    type: ON_KEY_UP_RECORDING_ACTIVITY,
    payload: {
        verticalPosition: index,
    },
});

export const onKeyDownRecordingActivityAction = (
    index: number,
): TivoPayloadAction<{ verticalPosition: number }> => ({
    type: ON_KEY_DOWN_RECORDING_ACTIVITY,
    payload: {
        verticalPosition: index,
    },
});
